import { LocaleInfo } from '@/objects';

// A lookup for all our languages and important data
const locales = [] as LocaleInfo[];
locales.push(new LocaleInfo('nb', 'no', 'Norsk', 160, 'no', 'nb_NO', ['nb-no', 'no', 'nb', 'nn'], 'no'));
locales.push(new LocaleInfo('en', 'en', 'English', 225, 'us', 'en_US', ['en'], 'en'));
locales.push(new LocaleInfo('sv', 'sv', 'Svenska', 205, 'se', 'sv_SE', ['sv', 'se'], 'sv'));
locales.push(new LocaleInfo('it', 'it', 'Italiano', 105, 'it', 'it_IT', ['it'], 'it'));
locales.push(new LocaleInfo('fi', 'fi', 'Suomi', 72, 'fi', 'fi_FI', ['fi'], 'fi'));
locales.push(new LocaleInfo('ru', 'ru', 'Россия', 0, 'ru', 'ru_RU', ['ru', 'tt'], 'ru'));
locales.push(new LocaleInfo('fr', 'fr', 'Français', 0, 'fr', 'fr_FR', ['fr'], 'fr'));
locales.push(new LocaleInfo('de', 'de', 'Deutsch', 0, 'de', 'de_DE', ['de'], 'de'));
locales.push(new LocaleInfo('es', 'es', 'Español', 199, 'es', 'es_ES', ['es'], 'es'));
locales.push(new LocaleInfo('et', 'et', 'Eesti', 67, 'ee', 'et_EE', ['et', 'ee'], 'et'));

// Filter out the active locales ( We only support NO, EN, SV for now)
export const activeLocales = locales.filter((x) => ['no', 'en', 'sv'].includes(x.Base));

const getLocaleByCode = (language: string): LocaleInfo | null => {
    const localeProps = language.split('-');
    // Get Major language
    language = localeProps[0];

    const items = locales.filter((x) => x.Codes.indexOf(language!.toLowerCase()) >= 0);
    if (!items.length) return null;

    return items[0];
};

/**
 * Find the preffered user language based on browser or previous selected setting
 * @returns
 */
export const getPreferredLanguage = (): LocaleInfo => {
    // Get the browser locale
    const userLocale = getLocaleByCode(navigator.language);

    // Get the saved i18next value
    const i18nLocale = getLocaleByCode(localStorage.getItem('i18nextLng') ?? '');

    return i18nLocale ?? userLocale ?? getLocaleByCode('en')!;
};
